import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  width?: number | string;
  height?: number | string;
}

const AIIcon: React.FunctionComponent<Props> = (props) => {
  const { width = 121, height = 59, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={width}
      height={height}
      viewBox='0 0 121 59'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <rect
        width='58.9183'
        height='58.9183'
        rx='17.6755'
        transform='matrix(1 0 -0.173648 0.984808 35.9629 0.676758)'
        fill='#F3F2FF'
        fillOpacity='0.75'
      />
      <mask
        id='mask0_10278_33174'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='43'
        y='15'
        width='35'
        height='30'>
        <path
          d='M77.5939 15.1846H48.1348L43.0192 44.1962H72.4784L77.5939 15.1846Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_10278_33174)'>
        <path
          d='M75.0132 16.7715C74.9216 16.7715 74.8275 16.8073 74.7515 16.8711C74.6755 16.9348 74.6239 17.0213 74.608 17.1115L73.2092 25.0443C73.1933 25.1345 73.2145 25.2209 73.2679 25.2848C73.3215 25.3485 73.4029 25.3843 73.4945 25.3843C73.5861 25.3843 73.6802 25.3485 73.7562 25.2848C73.8322 25.2209 73.8838 25.1345 73.8997 25.0443L75.2985 17.1115C75.3144 17.0213 75.2933 16.9348 75.2398 16.8711C75.1862 16.8073 75.1048 16.7715 75.0132 16.7715Z'
          fill='#BDB4FE'
        />
        <path
          d='M49.7506 17.1115L48.3518 25.0443C48.3359 25.1345 48.3571 25.2209 48.4105 25.2848C48.464 25.3485 48.5455 25.3843 48.6371 25.3843C48.7287 25.3843 48.8228 25.3485 48.8988 25.2848C48.9748 25.2209 49.0264 25.1345 49.0423 25.0443L50.441 17.1115C50.4569 17.0213 50.4358 16.9348 50.3823 16.8711C50.3288 16.8073 50.2473 16.7715 50.1558 16.7715C50.0642 16.7715 49.9701 16.8073 49.8941 16.8711C49.8181 16.9348 49.7665 17.0213 49.7506 17.1115Z'
          fill='#BDB4FE'
        />
        <path
          d='M74.5524 19.38C75.633 19.38 76.6611 18.5174 76.8488 17.4532C77.0364 16.389 76.3125 15.5264 75.2319 15.5264C74.1514 15.5264 73.1233 16.389 72.9356 17.4532C72.748 18.5174 73.4719 19.38 74.5524 19.38Z'
          fill='#6938EF'
        />
        <path
          d='M62.5445 16.999C54.5855 16.999 47.1142 22.9312 45.7418 30.7143L44.8289 35.8917C44.6366 36.9824 44.8921 38.0285 45.5392 38.7998C46.1864 39.571 47.1722 40.0043 48.2798 40.0043H54.6933C54.7922 40.0037 54.8818 40.0381 54.9457 40.1015C55.0094 40.1648 55.0432 40.2526 55.0406 40.3488C54.9885 41.0359 54.7221 41.7275 54.2767 42.332C54.1604 42.5049 54.0943 42.699 54.0867 42.8898C54.079 43.0804 54.1303 43.2593 54.2339 43.4038C54.3375 43.5483 54.4889 43.6519 54.669 43.7016C54.849 43.7512 55.0497 43.7447 55.2456 43.6829C57.157 43.0696 59.5795 41.9891 61.2481 40.1747C61.2954 40.1223 61.3531 40.0796 61.4164 40.05C61.4797 40.0204 61.5468 40.0048 61.6123 40.0043H68.6964C69.8039 40.0043 70.9425 39.571 71.8617 38.7998C72.7808 38.0285 73.4052 36.9824 73.5975 35.8917L74.5105 30.7143C75.8839 22.9312 70.5035 16.999 62.5445 16.999Z'
          fill='#6938EF'
        />
        <path
          d='M49.6858 37.0577C49.1365 37.0577 48.6475 36.8428 48.3265 36.4602C48.0055 36.0777 47.8788 35.5588 47.9742 35.0178L48.7535 30.598C49.7203 24.5301 55.9551 19.8468 62.0442 19.8321C68.1521 19.8171 72.717 24.5097 71.5383 30.598L70.759 35.0178C70.6636 35.5588 70.3539 36.0777 69.898 36.4602C69.4421 36.8428 68.8773 37.0577 68.3279 37.0577H49.6858Z'
          fill='#E7E5FE'
        />
        <path
          d='M49.697 19.38C50.7775 19.38 51.8056 18.5174 51.9933 17.4532C52.1809 16.389 51.4571 15.5264 50.3765 15.5264C49.2959 15.5264 48.2678 16.389 48.0802 17.4532C47.8925 18.5174 48.6164 19.38 49.697 19.38Z'
          fill='#6938EF'
        />
        <path
          d='M54.6521 29.1237C55.6055 29.1237 56.5126 28.3625 56.6781 27.4237C56.8437 26.4848 56.205 25.7236 55.2516 25.7236C54.2983 25.7236 53.3912 26.4848 53.2256 27.4237C53.0601 28.3625 53.6987 29.1237 54.6521 29.1237Z'
          fill='#6938EF'
        />
        <path
          d='M66.1599 29.1237C67.1133 29.1237 68.0204 28.3625 68.1859 27.4237C68.3515 26.4848 67.7128 25.7236 66.7595 25.7236C65.8061 25.7236 64.899 26.4848 64.7334 27.4237C64.5679 28.3625 65.2066 29.1237 66.1599 29.1237Z'
          fill='#6938EF'
        />
        <path
          d='M56.9504 30.7119C56.8479 30.7119 56.7429 30.7343 56.6428 30.7776C56.5426 30.8207 56.45 30.8836 56.3714 30.9618C56.2929 31.0398 56.2304 31.1312 56.1886 31.2291C56.1469 31.327 56.1268 31.429 56.1299 31.5279C56.1666 32.3954 56.5155 33.1726 57.1182 33.7301C57.7209 34.2877 58.5412 34.5918 59.4423 34.5918C60.3434 34.5918 61.2709 34.2877 62.0702 33.7301C62.8695 33.1726 63.4925 32.3954 63.8353 31.5279C63.8731 31.429 63.889 31.327 63.8818 31.2291C63.8746 31.1312 63.8444 31.0398 63.7933 30.9618C63.7424 30.8836 63.6718 30.8207 63.5869 30.7776C63.502 30.7343 63.4049 30.7119 63.3025 30.7119H56.9504Z'
          fill='#6938EF'
        />
      </g>
      <line
        x1='25.2441'
        y1='24.2451'
        x2='10.6734'
        y2='24.2451'
        stroke='#6938EF'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <line
        x1='23.8555'
        y1='32.124'
        x2='0.999323'
        y2='32.124'
        stroke='#6938EF'
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default AIIcon;
